import {
  SET_CLIENT_INFORMATION,
  SET_AUTH_INFORMATION,
  SET_LOADER_VISIBILITY,
  SET_JWT_AUTH_TOKEN,
  SET_NOTIFICATION_SUMMARY,
  SET_CLIENT_Session,
} from "../../../helpers/vuex-constants";
import {
  AuthService,
  ClientServices,
  EngagementServices,
  RiskProfileService,
} from "../../../services";
import auth from "../../../models/auth";
import client from "../../../models/client";
import engagementdashboard from "../../../models/engagementdashboard";
import riskprofiles from "../../../models/riskprofiles";
import {
  SET_ENGAGEMENT_COUNT,
  SET_RISK_PROFILE_DATA,
} from "../../../helpers/vuex-constants";

export default {
  setClientInformation: {
    root: true,
    async handler(context, payload) {
      const response = await ClientServices.getClientInformation(payload);
      const apidata = response.data;
      if (response.status == 200 && apidata.data.length >= 1) {
        context.commit(
          SET_CLIENT_INFORMATION,
          client.setClientInformation(apidata.data)
        );
      }
    },
  },
  setClientSession: {
    root: true,
    async handler(context, payload) {
      context.commit(SET_CLIENT_Session, payload);
    },
  },
  setAuthInformation: {
    root: true,
    async handler(context, payload) {
      try {
        const response = await AuthService.getAuthInformation(payload.key);
        if (response.status == 200 && response.data.length >= 1) {
          context.commit(
            SET_AUTH_INFORMATION,
            auth.setTokenInformation(response.data[0], payload)
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  setJWTAuthToken: {
    root: true,
    async handler(context, payload) {
      try {
        context.commit(SET_JWT_AUTH_TOKEN, payload);
      } catch (error) {
        console.log(error);
      }
    },
  },
  async setNotificationSummary(context, payload) {
    context.commit(SET_NOTIFICATION_SUMMARY, payload);
  },

  setJWTAuthInformation: {
    root: true,
    async handler(context, payload) {
      try {
        context.commit(
          SET_AUTH_INFORMATION,
          auth.setTokenInformation(payload, payload)
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  setLoaderVisibility: {
    root: true,
    async handler(context, payload) {
      context.commit(SET_LOADER_VISIBILITY, payload);
    },
  },
  setEngagementCount: {
    root: true,
    async handler(context, payload) {
      const response = await EngagementServices.getEngegementCount(payload);
      if (response.status == 200 && response.data) {
        context.commit(
          SET_ENGAGEMENT_COUNT,
          engagementdashboard.setEngagementResponse(response.data)
        );
      }
    },
  },
  setRiskProfileData: {
    root: true,
    async handler(context, payload) {
      if (!context.state.riskprofiledata.data) {
        const response = await RiskProfileService.getRiskProfileData(
          payload.companyId,
          payload.adviserId,
          payload.clientId
        );
        if (response.status == 200 && response.data.data) {
          context.commit(
            SET_RISK_PROFILE_DATA,
            riskprofiles.setriskprofileresponse(response.data.data)
          );
        }
      }
    },
  },
};
